import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { setSessionItem } from '@atlassian/search-dialog';
import { DEFAULT_EMPTY_NLP_SEARCH_STATE, SEARCH_AI_ANSWER_CACHE_KEY } from '../ai-answer-dialog';
import { getNonStreamFetchErrorEventPayload, getStreamFetchErrorEventPayload } from '../error-analytics';
import { AIAnswerQueryStreamType, NLPSearchErrorState, NLPSearchResultFormat } from '../types';
export var fetchAIAnswer = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var _partialResponseAbort;
    var cloudId, locale, query, additional_context, source, _ref$followUpsEnabled, followUpsEnabled, getAIAnswer, setLoading, partialResponse, partialResponseAbortControllerRef, setPartialResponse, setData, setAnswerStreamed, parsedFilters, isReadingAids, fireAnalyticsEvent, abortController, aiAnswer, processStreamResponse;
    return _regeneratorRuntime.wrap(function _callee2$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          cloudId = _ref.cloudId, locale = _ref.locale, query = _ref.query, additional_context = _ref.additional_context, source = _ref.source, _ref$followUpsEnabled = _ref.followUpsEnabled, followUpsEnabled = _ref$followUpsEnabled === void 0 ? false : _ref$followUpsEnabled, getAIAnswer = _ref.getAIAnswer, setLoading = _ref.setLoading, partialResponse = _ref.partialResponse, partialResponseAbortControllerRef = _ref.partialResponseAbortControllerRef, setPartialResponse = _ref.setPartialResponse, setData = _ref.setData, setAnswerStreamed = _ref.setAnswerStreamed, parsedFilters = _ref.parsedFilters, isReadingAids = _ref.isReadingAids, fireAnalyticsEvent = _ref.fireAnalyticsEvent;
          setLoading(true);
          if (partialResponse !== null && partialResponse !== void 0 && partialResponse.partialNlpResult) {
            // clean up any old partial responses
            setPartialResponse(undefined);
          }
          // end any old partial response streams
          (_partialResponseAbort = partialResponseAbortControllerRef.current) === null || _partialResponseAbort === void 0 || _partialResponseAbort.abort();
          abortController = new AbortController();
          partialResponseAbortControllerRef.current = abortController;

          // For graphQL getAIAnswer fns we expect each product to pass their own cloudIdARI in order for this component to be more product agnostic
          aiAnswer = getAIAnswer({
            variables: {
              query: query,
              additional_context: additional_context,
              locale: locale,
              filters: parsedFilters,
              experience: isReadingAids ? 'readingAids' : source,
              followUpsEnabled: followUpsEnabled
            }
          });
          processStreamResponse = /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(answer) {
              var next, answerFormat, _loop, streamEnd;
              return _regeneratorRuntime.wrap(function _callee$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return answer.stream.next();
                  case 3:
                    next = _context2.sent;
                    _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                      var streamEvent;
                      return _regeneratorRuntime.wrap(function _loop$(_context) {
                        while (1) switch (_context.prev = _context.next) {
                          case 0:
                            streamEvent = next.value;
                            if (streamEvent.type === AIAnswerQueryStreamType.AnswerType) {
                              answerFormat = streamEvent.message.format;
                            }
                            if (!(streamEvent.type === AIAnswerQueryStreamType.AnswerPart)) {
                              _context.next = 6;
                              break;
                            }
                            if (!(answerFormat !== NLPSearchResultFormat.MARKDOWN)) {
                              _context.next = 5;
                              break;
                            }
                            throw new Error("Unexpected format: ".concat(answerFormat));
                          case 5:
                            setPartialResponse(function (previousPartialResponse) {
                              var previousPartialNlpResult = (previousPartialResponse === null || previousPartialResponse === void 0 ? void 0 : previousPartialResponse.partialNlpResult) || '';
                              return {
                                format: NLPSearchResultFormat.MARKDOWN,
                                partialNlpResult: previousPartialNlpResult + streamEvent.message.nlpResult
                              };
                            });
                          case 6:
                            if (streamEvent.type === AIAnswerQueryStreamType.FinalResponse) {
                              setPartialResponse(undefined);
                              setData(streamEvent.message);
                              setLoading(false);
                            }
                            _context.next = 9;
                            return answer.stream.next();
                          case 9:
                            next = _context.sent;
                            if (!abortController.signal.aborted) {
                              _context.next = 12;
                              break;
                            }
                            throw 'Aborted';
                          case 12:
                          case "end":
                            return _context.stop();
                        }
                      }, _loop);
                    });
                  case 5:
                    if (next.done) {
                      _context2.next = 9;
                      break;
                    }
                    return _context2.delegateYield(_loop(), "t0", 7);
                  case 7:
                    _context2.next = 5;
                    break;
                  case 9:
                    streamEnd = next.value;
                    if (!abortController.signal.aborted) {
                      _context2.next = 12;
                      break;
                    }
                    throw streamEnd;
                  case 12:
                    if (!(streamEnd.state === 'complete')) {
                      _context2.next = 18;
                      break;
                    }
                    setPartialResponse(undefined);
                    setData(streamEnd.value.message);
                    setSessionItem(SEARCH_AI_ANSWER_CACHE_KEY, JSON.stringify({
                      query: query,
                      data: streamEnd.value.message
                    }));
                    _context2.next = 24;
                    break;
                  case 18:
                    if (!(streamEnd.reason === 'timeout')) {
                      _context2.next = 23;
                      break;
                    }
                    setPartialResponse(undefined);
                    setData({
                      errorState: NLPSearchErrorState.TimeoutError,
                      errorCode: 0,
                      format: null,
                      disclaimer: null,
                      nlpResults: [],
                      uniqueSources: [],
                      nlpFollowUpResults: null
                    });
                    _context2.next = 24;
                    break;
                  case 23:
                    throw streamEnd;
                  case 24:
                    _context2.next = 33;
                    break;
                  case 26:
                    _context2.prev = 26;
                    _context2.t1 = _context2["catch"](0);
                    fireAnalyticsEvent(getStreamFetchErrorEventPayload(_context2.t1, source));
                    if (!(_context2.t1 === 'Aborted')) {
                      _context2.next = 31;
                      break;
                    }
                    return _context2.abrupt("return");
                  case 31:
                    setPartialResponse(undefined);
                    setData({
                      errorState: NLPSearchErrorState.NetworkError,
                      errorCode: _context2.t1 !== null && _context2.t1 !== void 0 && _context2.t1.errorCode ? _context2.t1.errorCode : 0,
                      format: null,
                      disclaimer: null,
                      nlpResults: [],
                      uniqueSources: [],
                      nlpFollowUpResults: null
                    });
                  case 33:
                    _context2.prev = 33;
                    setAnswerStreamed(true);
                    setLoading(false);
                    return _context2.finish(33);
                  case 37:
                  case "end":
                    return _context2.stop();
                }
              }, _callee, null, [[0, 26, 33, 37]]);
            }));
            return function processStreamResponse(_x2) {
              return _ref3.apply(this, arguments);
            };
          }(); // If aiAnswer is an object with a type property -- it's a getAIAnswer
          // and we need to handle the new streaming response
          if (!('type' in aiAnswer)) {
            _context3.next = 11;
            break;
          }
          processStreamResponse(aiAnswer);
          return _context3.abrupt("return");
        case 11:
          _context3.next = 13;
          return aiAnswer.then(function (data) {
            if ('type' in data) {
              processStreamResponse(data);
              return;
            }
            setData((data === null || data === void 0 ? void 0 : data.nlpSearch) || DEFAULT_EMPTY_NLP_SEARCH_STATE);
            setSessionItem(SEARCH_AI_ANSWER_CACHE_KEY, JSON.stringify({
              query: query,
              data: (data === null || data === void 0 ? void 0 : data.nlpSearch) || DEFAULT_EMPTY_NLP_SEARCH_STATE
            }));
            setLoading(false);
          }).catch(function (error) {
            fireAnalyticsEvent(getNonStreamFetchErrorEventPayload(error, source));
            setData({
              errorState: error instanceof DOMException && error.name === 'TimeoutError' ? NLPSearchErrorState.TimeoutError : NLPSearchErrorState.NetworkError,
              format: null,
              disclaimer: null,
              nlpResults: [],
              uniqueSources: [],
              nlpFollowUpResults: null
            });
            setLoading(false);
          });
        case 13:
        case "end":
          return _context3.stop();
      }
    }, _callee2);
  }));
  return function fetchAIAnswer(_x) {
    return _ref2.apply(this, arguments);
  };
}();